import './metadataSettings.tpl.html';

angular
  .module('bulkRestore.metadataSettings', [])
  /**
   * Allows user select additional options while restoring metadata
   */
  .controller('BulkRestoreMetadataSettingsCtrl', [
    '$scope',
    '$state',
    '$filter',
    'WizardService',
    function ($scope, $state, $filter, WizardService) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      const i18n = $filter('i18n');
      const bulkRestoreData = $state.params.bulkRestoreData;

      // Register our page with the wizard service
      const page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('SELECT_RESTORE_SETTINGS'));
      page.setStateParams($state.params);
      // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this far.
      page.setTouched(true);

      $scope.isIgnoreWarnings = bulkRestoreData.isIgnoreWarnings;

      /**
       * Toggles whether the user wants to ignore warnings
       */
      $scope.toggleIgnoreWarnings = function () {
        bulkRestoreData.setIgnoreWarnings(!bulkRestoreData.isIgnoreWarnings());
      };
    }
  ]);
